<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Recharges</h1>
      </template>
      <template #actions>
        <page-header-action tag="router-link" to="/recharges/create">
          Add Recharge
        </page-header-action>
      </template>
    </page-header>
    <div class="card mb-3">
      <div class="loading-overlay" v-if="loading"></div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Claim Reference</th>
              <th>Invoice Number</th>
              <th>Cost</th>
              <th>Recharge Amount</th>
              <th>Outstanding</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="index" v-for="(recharge, index) in recharges">
              <td>{{ recharge.incident?.source?.claim_reference }}</td>
              <td>{{ recharge.invoice_number }}</td>
              <td>{{ recharge.cost | currency }}</td>
              <td>{{ recharge.recharge_amount | currency }}</td>
              <td>{{ recharge.outstanding | currency }}</td>
              <td>
                <router-link
                  class="btn btn-primary"
                  :to="`/recharges/${recharge.identifier}/edit`"
                >
                  Edit
                </router-link>
              </td>
            </tr>
            <tr v-if="!recharges.length">
              <td class="text-center" colspan="5">
                No recharges found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right">
        <pagination
          :data="paginator_data"
          v-on:updateResults="getData"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      recharges: [],
      paginator_data: {},
      filters: {},
      loading: true,
      indicator: false
    };
  },

  mounted() {
    this.loadFleet();
  },

  methods: {
    loadFleet() {
      this.getData(`/recharges?per_page=${this.perPage}&parts=incident`);
    },

    getData(url) {
      this.loading = true;

      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key]}`;
      });

      window.Ajax.get(url)
        .then(response => {
          this.loading = false;
          this.recharges = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(err => {});
    }
  }
};
</script>
